<div class="wrapper">
	<img src="assets/images/langs/{{ language | lowercase }}.svg"/>
</div>